<template>
  <div class="player-page">
    <!-- 使用组件原生left‑arrow，不要自定义#left插槽，H5手机浏览器渲染最稳 -->
    <van-nav-bar
      title="播放"
      left-arrow
      @click-left="$router.back()"
    />

    <!-- 影片名称区域 -->
    <div class="info-bar">
      <h2 class="video-title">{{ title }}</h2>
    </div>

    <div class="video-wrap">
      <video
        ref="videoEl"
        class="video-container"
        controls
        playsinline
        webkit-playsinline
        @timeupdate="onVideoTimeUpdate"
        @seeking="onSeeking"
      ></video>
      <!-- 播放遮罩 -->
      <div v-if="showMask" class="play-mask" @click="startPlay">
        <van-icon name="play-circle" size="60" color="#fff" />
        <p style="color:#fff;margin-top:10px">点击播放</p>
      </div>
      <!-- 加载缓冲提示 -->
      <div v-if="loading" class="loading-mask">
        <van-loading color="#fff" size="30"/>
      </div>

      <!-- ========== 底部试看倒计时遮罩【新增】 ========== -->
      <div v-if="isVip === 0 && !trialTriggered" class="trial-bar">
        <span>仅可试看，剩余 <strong>{{ remainSecond }}</strong> 秒</span>
        <van-button size="small" type="warning" @click="goVipBuy">开通会员</van-button>
      </div>

      <!-- ========== 试看结束弹窗 ========== -->
      <div v-if="showVipPopup" class="vip-popup">
        <div class="popup-box">
          <h3>试看已结束</h3>
          <p>开通VIP会员即可观看完整影片</p>
          <div class="btn-group">
            <van-button size="small" @click="goBack">返回</van-button>
            <van-button type="primary" size="small" @click="goVipBuy">开通会员</van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 同类型推荐 -->
    <div class="recommend-block">
      <h3 class="recommend-title">相似视频</h3>
      <div class="recommend-list">
        <div
          class="recommend-item"
          v-for="item in recommendList"
          :key="item.id"
          @click="switchPlay(item)"
        >
          <div class="recommend-cover">
            <img :src="item.vod_pic" alt="">
            <div class="play-icon">▶</div>
          </div>
          <div class="recommend-name">{{ item.vod_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'
export default {
  name: 'livePlayer',
  data() {
    return {
      hlsPlayer: null,
      showMask: false,
      loading: false,
      m3u8Url: '',
      title: '',
      typeId: 0,
      videoId: 0,
      recommendList: [],

      // 会员&试看参数
      isVip: 0,          // 1=会员 0=非会员
      trySeconds: 20,    // 总试看时长（秒）
      showVipPopup: false,
      trialTriggered: false, // 是否触发试看结束
      remainSecond: 0,    // 剩余试看秒数
      lastSafeTime: 0     // 防拖拽进度条
    }
  },
  mounted() {
    this.parseRouteQuery()
    this.startPlay()
    this.getRecommend()
  },
  beforeUnmount() {
    this.destroyPlayer()
  },
  methods: {
    // 解析路由参数抽离方法，复用
    parseRouteQuery() {
      const query = this.$route.query
      this.m3u8Url = query.flvUrl || ''
      this.title = query.title || '播放视频'
      this.typeId = Number(query.type_id) || 0
      this.videoId = Number(query.id) || 0
      // 读取会员、试看参数
      this.isVip = Number(query.is_vip || 0)
      this.trySeconds = Number(query.try_seconds || 20)
      this.remainSecond = this.trySeconds
    },

    destroyPlayer() {
      if (this.hlsPlayer) {
        this.hlsPlayer.destroy()
        this.hlsPlayer = null
      }
    },

    startPlay() {
      if (!this.m3u8Url) {
        this.$toast('播放地址为空')
        return
      }
      this.showMask = false
      this.loading = true
      const videoDom = this.$refs.videoEl
      this.destroyPlayer()

      // =========兼容核心逻辑=========
      // 情况1：支持Hls（Chrome、安卓浏览器、Edge、Firefox）
      if (Hls.isSupported()) {
        this.hlsPlayer = new Hls({
          maxBufferLength: 20,
          maxMaxBufferLength: 40
        })
        this.hlsPlayer.loadSource(this.m3u8Url)
        this.hlsPlayer.attachMedia(videoDom)

        this.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, () => {
          this.loading = false
          videoDom.play().catch(() => {
            this.showMask = true
          })
        })

        this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
          console.error('播放异常', data)
          this.loading = false
          // 致命错误
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                // 网络错误尝试恢复
                this.hlsPlayer.startLoad()
                break
              case Hls.ErrorTypes.MEDIA_ERROR:
                this.hlsPlayer.recoverMediaError()
                break
              default:
                this.$toast('视频加载失败')
                this.showMask = true
                break
            }
          }
        })
      }
      // 情况2：IOS Safari原生支持m3u8，不需要hls.js
      else if (videoDom.canPlayType('application/vnd.apple.mpegurl')) {
        videoDom.src = this.m3u8Url
        videoDom.play().catch(() => {
          this.showMask = true
        })
        videoDom.addEventListener('loadedmetadata', () => {
          this.loading = false
        })
      } else {
        this.loading = false
        this.$toast('当前浏览器不支持播放')
        this.showMask = true
      }
    },

    // 用户拖拽进度条事件
    onSeeking() {
      const videoDom = this.$refs.videoEl
      // VIP会员 允许任意拖动进度条
      if (this.isVip === 1) {
        return
      }
      // 非会员：禁止拖拽到试看时长以外
      if (videoDom.currentTime > this.trySeconds) {
        videoDom.currentTime = this.lastSafeTime
        this.$toast('无法拖动到试看区域外！')
      }
    },

    // 视频播放时间监听【试看核心】
    onVideoTimeUpdate() {
      // VIP直接放行，不限制
      if (this.isVip === 1 || this.trialTriggered) return;

      const videoDom = this.$refs.videoEl
      const currentTime = videoDom.currentTime
      this.lastSafeTime = currentTime
      // 实时计算剩余秒数
      this.remainSecond = Math.ceil(this.trySeconds - currentTime)

      // 播放时长 >= 试看时长，触发限制
      if (currentTime >= this.trySeconds) {
        this.trialTriggered = true
        videoDom.pause()
        this.showVipPopup = true
      }
    },

    // 获取同类推荐
    getRecommend() {
      if (!this.typeId) {
        this.recommendList = []
        return
      }
      let that = this
      that.$apiFun.get(`/api/getRecommend?type_id=${that.typeId}&exclude_id=${that.videoId}&limit=10`)
        .then(res => {
          if (res.code === 200) {
            that.recommendList = res.data
          } else {
            that.recommendList = []
          }
        })
        .catch(err => {
          console.log("推荐加载失败", err)
          that.recommendList = []
        })
    },

    // 点击推荐切换视频
    switchPlay(item) {
      this.m3u8Url = item.vod_play_url
      this.title = item.vod_name
      this.videoId = item.id
      this.typeId = item.type_id

      // 切换视频必须重置试看状态
      this.trialTriggered = false
      this.showVipPopup = false
      this.remainSecond = this.trySeconds
      this.lastSafeTime = 0

      this.startPlay()
      this.getRecommend()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    // 返回上一页
    goBack() {
      this.$router.back()
    },
    // 跳转到会员购买页面（自行修改路由）
    goVipBuy() {
      this.$router.push('/vipBuy')
    }
  }
}
</script>

<style lang="scss" scoped>
.player-page {
  background: #000;
  min-height: 100vh;
  overflow-x: hidden;
  padding-bottom: 20px;
}

.info-bar {
  padding: 12px 16px;
  .video-title {
    color: #fff;
    font-size: 17px;
    margin: 0;
  }
}

.video-wrap {
  width: 100%;
  position: relative;
  background: #000;

  .video-container {
    width: 100%;
    display: block;
    object-fit: cover;
  }

  .play-mask, .loading-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
  }

  // ==========底部试看倒计时遮罩样式 ==========
  .trial-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.72);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    color: #fff;
    font-size: 14px;
    z-index: 10;
    strong {
      color: #ff5544;
      font-size: 16px;
    }
  }

  // 试看弹窗样式
  .vip-popup {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    .popup-box {
      background: #fff;
      border-radius: 12px;
      padding: 24px 20px;
      width: 80%;
      max-width: 320px;
      text-align: center;
      h3 {
        margin: 0 0 8px;
        font-size: 18px;
      }
      p {
        color: #666;
        margin-bottom: 20px;
        font-size:14px;
      }
      .btn-group{
        display:flex;
        gap:12px;
        justify-content:center;
      }
    }
  }
}

// 推荐区域
.recommend-block {
  margin-top: 16px;
  padding: 0 12px;
  .recommend-title {
    color: #fff;
    font-size: 16px;
    margin: 10px 0;
  }
  .recommend-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .recommend-item {
      width: calc(50% - 5px);
      .recommend-cover {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        background: #222;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          object-fit: cover;
        }
        .play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 24px;
        }
      }
      .recommend-name {
        color: #eee;
        font-size: 13px;
        padding: 6px 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/livePlayer.vue